import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'mg-divider',
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    // 是否是垂直布局
    showLine: {
      type: Boolean,
      default: true
    },
    // 是否显示分割线
    size: {
      type: [String, Number],
      default: '9px'
    } // 分割线大小
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", {
        style: _normalizeStyle({
          '--mg-ui-size-divider-size': __props.size
        }),
        class: _normalizeClass(['mg-dividing-line', {
          'is--show-line': __props.showLine,
          'is--horizontal': !__props.vertical,
          'is--vertical': __props.vertical
        }])
      }, null, 6);
    };
  }
};